"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.coerceEnumValue = exports.assertIsEnumValue = exports.fold = exports.asSingleton = exports.enumReverseMap = exports.Enum = exports.cast = void 0;
const Set_1 = require("fp-ts/lib/Set");
const t = __importStar(require("io-ts"));
const io_ts_reporters_1 = require("io-ts-reporters");
const errors_1 = require("../errors");
/**
 * Cast an unknown value using an `io-ts` schema. If validation fails, throw an error.
 * If it passes, cast the value to the schema's interface.
 * @param {unknown} data - Object to validate
 * @param {T} schema - Schema to validate against
 * @param {boolean?} includeDataInError - Whether to include data in error or not.
 * @returns {t.TypeOf<T>} the validated object
 */
function cast(data, schema, includeDataInError = false) {
    const decoded = schema.decode(data);
    if (decoded.isLeft()) {
        const errors = (0, io_ts_reporters_1.reporter)(decoded);
        throw new errors_1.CastError(errors, includeDataInError ? data : undefined);
    }
    return data;
}
exports.cast = cast;
/**
 * Convert a typescript enum to an io-ts enum
 * @see https://github.com/gcanti/io-ts/issues/216
 * @example backend/src/types/delivery.ts
 */
class Enum extends t.Type {
    constructor(e, name) {
        super(name || 'enum', (u) => Object.values(this.enumObject).some((v) => v === u), (u, c) => (this.is(u) ? t.success(u) : t.failure(u, c)), t.identity);
        // tslint:disable-next-line:variable-name
        // eslint-disable-next-line @typescript-eslint/prefer-as-const
        this._tag = 'EnumType';
        this.enumObject = e;
    }
}
exports.Enum = Enum;
/**
 * Given an arbitrary enumeration, generate the reverse lookup map.
 *
 * @param {object} enumeration
 * The enumeration.
 *
 * @returns {Map}
 * A Mapping where the key is the value and the value is the key.
 */
function enumReverseMap(enumeration) {
    return new Map(Object.entries(enumeration).map(([key, value]) => [value, key]));
}
exports.enumReverseMap = enumReverseMap;
/**
 * Given a constructor, cast it as a singleton.
 *
 * @param {T} constructor
 * A constructor.
 *
 * @returns {T}
 * The constructor is returned, wrapped in Proxy such that it returns the first instance
 * of itself.
 */
function asSingleton(constructor) {
    let instance;
    return new Proxy(constructor, {
        construct: (target, args) => ((instance = instance || new target(...args)), instance),
    });
}
exports.asSingleton = asSingleton;
/**
 * Given an instance of `Eq<V>`, returns a function to fold an array of `V`s
 * into a set of `V`s
 */
const fold = (E) => (vs) => vs.reduce((acc, v) => (0, Set_1.union)(E)(acc, (0, Set_1.singleton)(v)), Set_1.empty);
exports.fold = fold;
/**
 * assert a given value appears in the given enumeration
 * @throws {Error} an error if the value does not appear in the given enumeration
 */
function assertIsEnumValue(value, sourceEnum) {
    const enumValues = Object.values(sourceEnum);
    if (!enumValues.includes(value)) {
        throw new errors_1.EnumMemberNotFoundError(value, enumValues);
    }
}
exports.assertIsEnumValue = assertIsEnumValue;
/**
 * Accepts a string | number and casts it to an enum type, throwing an
 * error if the given value is not assignable to the given enum
 */
const coerceEnumValue = (value, sourceEnum) => {
    assertIsEnumValue(value, sourceEnum);
    return value;
};
exports.coerceEnumValue = coerceEnumValue;
//# sourceMappingURL=mapping.js.map